"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageTag = void 0;
/**
 * Vista supported IETF language tags as per cinema.tblLanguage.
 */
var LanguageTag;
(function (LanguageTag) {
    LanguageTag["Arabic"] = "ar";
    LanguageTag["Bulgarian"] = "bg-BG";
    LanguageTag["Bosnian"] = "bs-Latn-BA";
    LanguageTag["Czech"] = "cs-CZ";
    LanguageTag["Danish"] = "da-DK";
    LanguageTag["GermanSwitzerland"] = "de-CH";
    LanguageTag["GermanGermany"] = "de-DE";
    LanguageTag["Greek"] = "el-GR";
    LanguageTag["English"] = "en";
    LanguageTag["EnglishSingapore"] = "en_SG";
    LanguageTag["EnglishUnitedStates"] = "en-US";
    /**
     * Test language used by Vista developers.
     * Adds a bunch of "X"s to the English text to test that translations are working correctly.
     */
    LanguageTag["VistaDeveloperTest"] = "eo-VISTA";
    LanguageTag["SpanishLatinAmerica"] = "es-419";
    LanguageTag["Spanish"] = "es-ES";
    LanguageTag["SpanishMexico"] = "es-MX";
    LanguageTag["Estonian"] = "et-EE";
    LanguageTag["Finnish"] = "fi-FI";
    LanguageTag["FrenchBelgium"] = "fr-BE";
    LanguageTag["FrenchCanada"] = "fr-CA";
    LanguageTag["FrenchSwitzerland"] = "fr-CH";
    LanguageTag["French"] = "fr-FR";
    LanguageTag["Croatian"] = "hr-HR";
    LanguageTag["Hungarian"] = "hu-HU";
    LanguageTag["Armenian"] = "hy";
    LanguageTag["Icelandic"] = "is-IS";
    LanguageTag["Italian"] = "it-IT";
    LanguageTag["Japanese"] = "ja-JP";
    LanguageTag["Khmer"] = "km-KH";
    LanguageTag["Lithuanian"] = "lt-LT";
    LanguageTag["Latvian"] = "lv-LV";
    LanguageTag["Macedonian"] = "mk-MK";
    LanguageTag["Mongolian"] = "mn-MN";
    LanguageTag["Norwegian"] = "nb-NO";
    LanguageTag["DutchBelgium"] = "nl-BE";
    LanguageTag["DutchNetherlands"] = "nl-NL";
    LanguageTag["PortugueseBrazil"] = "pt-BR";
    LanguageTag["Portuguese"] = "pt-PT";
    LanguageTag["Romanian"] = "ro-RO";
    LanguageTag["Russian"] = "ru-RU";
    LanguageTag["Slovenian"] = "sl-SI";
    LanguageTag["Albanian"] = "sq-AL";
    LanguageTag["SerbianLatinMontenegro"] = "sr-Latn-ME";
    LanguageTag["SerbianLatinSerbia"] = "sr-Latn-RS";
    LanguageTag["Swedish"] = "sv-SE";
    LanguageTag["Thai"] = "th-TH";
    LanguageTag["Turkish"] = "tr-TR";
    LanguageTag["Ukrainian"] = "uk-UA";
    LanguageTag["Vietnamese"] = "vi-VN";
    LanguageTag["ChineseSimplified"] = "zh-CN";
    LanguageTag["ChineseTraditional"] = "zh-TW";
})(LanguageTag = exports.LanguageTag || (exports.LanguageTag = {}));
//# sourceMappingURL=language-tag.js.map